import { render, staticRenderFns } from "./HealthChange.vue?vue&type=template&id=0527711e&"
import script from "./HealthChange.vue?vue&type=script&lang=js&"
export * from "./HealthChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports